export default {
    // 获取文件历史
    getHistroyFile: {
        url: "/fileList",
        method: "get"
    },

    // 新增 app
    addNewApp: {
        url: "/app/newApp",
        method: "post"
    },

    // 获取 app 列表
    getAppList: {
        url: "/app/list",
        method: "get"
    },

    // 更新 app 列表
    updateApp: {
        url: "/app/publish",
        method: "post"

    },

    // 上传文件
    uploadCos: {
        url: "/uploadCos",
        method: "post"

    },

    // 刷新CDN
    refreshCDN: {
        url: "/refreshCDN",
        method: "post"
    },

    // 获取CDN刷新配额
    getRefreshCDNQuota: {
        url: "/getRefreshCDNQuota",
        method: "get"
    },

    // 获取CDN配额--华为云
    getCDNQuota: {
        url: "/getCDNQuota",
        method: "get"
    },

    // 预热CDN
    preheatCDN: {
        url: "/preheatCDN",
        method: "post"
    },

    // 获取CDN预热配额
    getPreheatCDNQuota: {
        url: "/getPreheatCDNQuota",
        method: "get"
    },

    // 上传icon  上传公共组件
    openApi: {
        url: "/openApi",
        method: "post"
    },

    // 上传文件夹 
    uploadDirectory: {
        url: "/uploadDirectory",
        method: "post"
    },

    // 上传文件夹并压缩
    uploadDirectoryAndCompressed: {
        url: "/uploadDirectoryAndCompressed",
        method: "post"
    },

    // 获取最近文件列表
    getLatestFileList: {
        url: "/getLatestFileList",
        method: "post"
    },

    // 获取最近7天文件数量
    getOneWeekFileList: {
        url: "/getOneWeekFileList",
        method: "get"
    },

    // 判断文件是否存在
    doesFileExist: {
        url: "/doesFileExist",
        method: "post"
    },
}
